import { FC } from 'react';
import * as Select from '@radix-ui/react-select';
import classNames from 'classnames';

import { icon_chevron_down, icon_chevron_up } from '@gn-audio/icons';
import { JabraIcon, useFallbackTranslation } from '@gn-audio/jss-components';

import {
  JabraRadioButton,
  JabraRadioButtonTheme,
  JabraRadioGroup,
} from 'common/components/JabraRadioGroup';
import { SoundDemoEnvironmentSelectProps } from 'components/Product/SoundDemo/soundDemoTypes';

export const SoundDemoEnvironmentSelect: FC<SoundDemoEnvironmentSelectProps> = ({
  SoundDemoEnvironments,
  selectOpen,
  setSelectOpen,
  selectedDemoEnvironment,
  setSelectedDemoEnvironment,
  setIsPlaying,
}) => {
  const { t } = useFallbackTranslation();

  const groupHoverClasses =
    `transition-colors duration-300 ease-linear ` +
    `group-hover:bg-primary group-hover:text-on-brand ` +
    `group-[:hover:not(:has(.env-play:hover))]:bg-gray-700 ` +
    `group-[:hover:not(:has(.env-play:hover))]:text-white ` +
    `group-[:hover:not(:has(.env-play:hover))]:stroke-white`;

  return (
    <Select.Root
      open={selectOpen}
      onOpenChange={(open) => setSelectOpen(open)}
      defaultValue={SoundDemoEnvironments[0].EnvironmentName?.value}
      value={selectedDemoEnvironment}
      onValueChange={(value) => {
        setSelectedDemoEnvironment(value);
        setIsPlaying(false);
      }}
    >
      <Select.Trigger
        aria-controls=""
        aria-label={t('system.Environments')}
        className={classNames(
          'env-select flex size-16 items-center justify-center rounded-full stroke-black focus-visible:rounded-full focus-visible:outline-focus',
          groupHoverClasses
        )}
      >
        {!selectOpen ? (
          <Select.Icon asChild>
            <JabraIcon className="icon h-3" Icon={icon_chevron_down} />
          </Select.Icon>
        ) : (
          <Select.Icon asChild>
            <JabraIcon className="icon h-3" Icon={icon_chevron_up} />
          </Select.Icon>
        )}
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          avoidCollisions={false}
          position="popper"
          align="end"
          className="w-60 overflow-hidden rounded-b-2xl bg-gray-900 px-4 pb-4 pt-3 text-white"
        >
          <Select.Viewport>
            <JabraRadioGroup selected={selectedDemoEnvironment} className="flex flex-col gap-1">
              {SoundDemoEnvironments.map((environment) => (
                <Select.Item
                  key={environment.id}
                  value={environment.EnvironmentName?.value}
                  className={`${selectedDemoEnvironment === environment.EnvironmentName?.value && 'text-primary'} outline-none focus-visible:rounded-full focus-visible:-outline-offset-2 focus-visible:outline-focus`}
                >
                  <JabraRadioButton
                    value={environment.EnvironmentName?.value}
                    title={environment.EnvironmentName?.value}
                    theme={JabraRadioButtonTheme.dark}
                  />
                </Select.Item>
              ))}
            </JabraRadioGroup>
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};
